import { baseUrl } from 'Api';

// Generates a section title + 5–7 video prompts via our BE's OpenAI
// proxy. POSTs the user's description to `${baseUrl}/ai/generate-questions`;
// the BE forwards to OpenAI's Responses API with the system prompt and
// parses the model's JSON before returning to us.
//
// Returns { title, questions: string[] } or throws.

const ENDPOINT_PATH = '/ai/generate-questions';

export async function generateSectionWithAI(description) {
  const desc = (description || '').trim();
  if (!desc) throw new Error('Please describe what this section is about.');

  const res = await fetch(`${baseUrl}${ENDPOINT_PATH}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ description: desc }),
  });

  if (!res.ok) {
    let detail = '';
    try {
      const data = await res.json();
      detail = (data && data.error) || '';
    } catch (e) {
      try { detail = (await res.text()).slice(0, 300); } catch (e2) { /* noop */ }
    }
    throw new Error(detail || `Generation failed (HTTP ${res.status}).`);
  }

  const data = await res.json();
  const title = typeof data.title === 'string' ? data.title.trim() : '';
  const questions = Array.isArray(data.questions)
    ? data.questions
      .map((q) => (typeof q === 'string' ? q.trim() : ''))
      .filter(Boolean)
    : [];

  if (!title || questions.length === 0) {
    throw new Error('AI response was incomplete. Try regenerating.');
  }
  return { title, questions };
}
